<span
  class="department-paused-badge"
  [class.department-paused-badge--icon-only]="iconOnly"
  [attr.aria-label]="iconOnly ? ('paused' | translate) : null"
  [attr.role]="iconOnly ? 'img' : null"
>
  <img class="department-paused-icon" src="assets/icons/paused.svg" alt="" aria-hidden="true" />
  @if (!iconOnly) {
    <span class="department-paused-label">{{ 'paused' | translate }}</span>
  }
</span>
